<template>
  <form
    ref="mainForm"
    class="pwd-edit-form"
    @submit.prevent="submit()"
  >
    <div class="pwd-edit-form__wrapper">
      <div class="pwd-edit-form__wrapper__labels">
        <label class="legend" :for="`pass-former${index}`">
          {{ $t('message.OLD_PASSWORD') + $t('message.TWO_DOTS') }}
        </label>
        <label class="legend" :for="`pass-new${index}`">
          {{ $t('message.NEW_PASSWORD') + $t('message.TWO_DOTS') }}
        </label>
        <label class="legend" :for="`pass-newc${index}`">
          {{ $t('message.NEW_PASSWORD_CONFIRM') + $t('message.TWO_DOTS') }}
        </label>
      </div>
      <div class="pwd-edit-form__wrapper__fields">
        <input
          :id="`pass-former${index}`"
          ref="formerField"
          v-model="passFormer"
          class="generic-border generic-border--thin-border generic-border--focus-shadow"
          type="password"
        >

        <input
          :id="`pass-new${index}`"
          v-model="passNew"
          class="generic-border generic-border--thin-border generic-border--focus-shadow"
          type="password"
        >

        <input
          :id="`pass-newc${index}`"
          v-model="passNewConfirm"
          class="generic-border generic-border--thin-border generic-border--focus-shadow"
          type="password"
        >
      </div>
    </div>
    <button class="mt5 generic-border generic-border--text-btn generic-border--blue pwd-edit-form__save" type="submit">
      {{ $t("message.SAVE") }}
    </button>
    <div style="height: 10px;width:1px" />
  </form>
</template>

<script>
/**
 * Triple field to edit a team/user/company password
 *
 * @vue-prop {Number} [index=1] - When using multiple forms, specify a different index to prevent
 *                                having the same HTML ids between fields
 * @vue-prop {Boolean} [focusOnMount=false] - If true, focus the first field on mount
 */

import $ from 'jquery';

export default {

  name: 'PwdEditForm',

  props: {
    index: {
      type: Number,
      default: 1,
    },
    focusOnMount: Boolean,
  },

  data() {
    return {
      passFormer: '',
      passNew: '',
      passNewConfirm: '',
    };
  },

  mounted() {
    if (this.focusOnMount) {
      this.$refs.formerField.focus();
    }
  },

  methods: {
    submit() {
      this.$emit('submit', this.passFormer, this.passNew, this.passNewConfirm);
    },
  },
};
</script>

<style lang="scss">

.pwd-edit-form {
  display: inline-block;

  &__wrapper {
    display: flex;

    &__labels {
      flex: 0 0 auto;

      label {
        display: block;
        padding: 0.55rem;
        height: 1.4rem;
        margin-top: 0.3rem;
      }
    }
    &__fields {
      flex: 1;
      margin-left: 0.5em;

      input {
        display: block;
        min-width: 4rem;
        width: 100%;
        height: 2.5rem;
        box-sizing: border-box;
        padding: 0.4rem;
        margin-top: 0.3rem;
        outline: none;
      }
    }
  }

  &__save.action-btn {
    margin: 1em auto;
    display: block;
  }
}
</style>
